<script setup>
import { ref } from 'vue'

const props = defineProps({
  width: {
    type: String,
    default: '100%'
  },
  minHeight: {
    type: String,
    default: '400px'
  },
  contentClass: {
    type: String
  },
  contentStyle: {
    type: [String, Object]
  },
  toggleClass: {
    type: String
  },
  toggleStyle: {
    type: [String, Object]
  },
  expandText: {
    type: String,
    default: 'Show more'
  },
  collapseText: {
    type: String,
    default: 'Show less'
  }
})

const expanded = ref(false)

const toggle = () => {
  expanded.value = !expanded.value
}
</script>

<template>
  <div>
    <div
      :class="[
        'fou-preview__content',
        { 'fou-preview__mask': !expanded, 'fou-preview__expand': expanded },
        contentClass
      ]"
      :style="contentStyle"
    >
      <slot name="content" />
    </div>
    <div :class="['fou-preview__toggle', toggleClass]" :style="toggleStyle">
      <slot name="toggle">
        <button
          type="button"
          class="mt-link mt-link--undecorated"
          @click="toggle"
        >
          {{ expanded ? collapseText : expandText }}
        </button>
      </slot>
    </div>
  </div>
</template>

<style>
.fou-preview__content {
  position: relative;
  text-align: justify;
  width: v-bind(width);
  height: v-bind(minHeight);
  min-height: v-bind(minHeight);
  overflow: clip;
}

.fou-preview__expand {
  height: auto;
  transition: height 0.25s ease-in;
}

.fou-preview__mask::after {
  content: '';
  position: absolute;
  display: block;
  bottom: 0;
  left: 0;
  pointer-events: none;
  height: 3.5rem;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 90%
  );
  z-index: 1;
  transition: height 0.25s ease-out;
}
</style>
